import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaTruck, FaUndo, FaLock, FaTrophy, FaAppleAlt, FaCarrot, FaGlassMartiniAlt, FaDrumstickBite, FaBreadSlice, FaIceCream } from 'react-icons/fa'; 
import { MdEmojiFoodBeverage } from "react-icons/md";
import { PiPaintBrushHouseholdBold } from "react-icons/pi";
import { FaBabyCarriage } from "react-icons/fa";
import { FaSpa } from 'react-icons/fa';

// react-spring for animation
import { useSpring, animated } from '@react-spring/web';

// Features Section (Top Section)
const FeaturesSection = () => {
  const iconAnimation = useSpring({
    opacity: 1,
    transform: 'translateY(0)',
    from: { opacity: 0, transform: 'translateY(20px)' },
    config: { tension: 180, friction: 12 },
  });

  return (
    <section
      style={{
        backgroundColor: '#34A853',
        color: '#fff',
        padding: '10px 0',
        border: '1px solid #fff',
        borderRadius: '8px',
        marginTop: '0px',
      }}
    >
      <Container style={{ paddingLeft: '15px', paddingRight: '15px' }}>
        {/* Feature Icons */}
        <Row className="text-center">
          {/* Free Shipping */}
          <Col md={3} sm={6} className="mb-3">
            <animated.div style={iconAnimation}>
              <FaTruck size={40} />
              <h5>Free Shipping</h5>
              <p>When ordering over $100</p>
            </animated.div>
          </Col>

          {/* Free Return */}
          <Col md={3} sm={6} className="mb-3">
            <animated.div style={iconAnimation}>
              <FaUndo size={40} />
              <h5>Free Return</h5>
              <p>Get Return within 30 days</p>
            </animated.div>
          </Col>

          {/* Secure Payment */}
          <Col md={3} sm={6} className="mb-3">
            <animated.div style={iconAnimation}>
              <FaLock size={40} />
              <h5>Secure Payment</h5>
              <p>100% Secure Online Payment</p>
            </animated.div>
          </Col>

          {/* Best Quality */}
          <Col md={3} sm={6} className="mb-3">
            <animated.div style={iconAnimation}>
              <FaTrophy size={40} />
              <h5>Best Quality</h5>
              <p>Original Product Guaranteed</p>
            </animated.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

// Market Category Section (Below the Features Section)
const MarketCategory = () => {
  const categoryAnimation = useSpring({
    opacity: 1,
    transform: 'translateX(0)',
    from: { opacity: 0, transform: 'translateX(-20px)' },
    delay: 200, 
    config: { tension: 180, friction: 12 },
  });

  return (
    <section style={{ backgroundColor: '#f9f9f9', padding: '30px 0' }}>
      <Container>
        <Row className="mb-4">
          <Col>
            <h3 style={{ fontWeight: 'bold' }}>Market Category</h3>
          </Col>
        </Row>
        <Row>
          {/* Fruits Category */}
          <Col md={2} sm={4} className="text-center mb-4 d-flex justify-content-center">
            <animated.div style={categoryAnimation}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '200px',
                }}
              >
                <FaAppleAlt size={50} color="#D32F2F" />
                <h5>Fruits</h5>
              </div>
            </animated.div>
          </Col>

          {/* Vegetables Category */}
          <Col md={2} sm={4} className="text-center mb-4 d-flex justify-content-center">
            <animated.div style={categoryAnimation}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '200px',
                }}
              >
                <FaCarrot size={50} color="#FF9800" />
                <h5>Vegetables</h5>
              </div>
            </animated.div>
          </Col>

          {/* Household Cleaning Category */}
          <Col md={2} sm={4} className="text-center mb-4 d-flex justify-content-center">
            <animated.div style={categoryAnimation}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '200px',
                }}
              >
                <PiPaintBrushHouseholdBold size={50} color="#00796B" />
                <h5>Household Cleaning</h5>
              </div>
            </animated.div>
          </Col>

          {/* Beverage Category */}
          <Col md={2} sm={4} className="text-center mb-4 d-flex justify-content-center">
            <animated.div style={categoryAnimation}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '200px',
                }}
              >
                <MdEmojiFoodBeverage size={50} color="#D32F2F" />
                <h5>Beverage</h5>
              </div>
            </animated.div>
          </Col>

          {/* Baby and Pet Care Category */}
          <Col md={2} sm={4} className="text-center mb-4 d-flex justify-content-center">
            <animated.div style={categoryAnimation}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '200px',
                }}
              >
                <FaBabyCarriage size={50} color="#6D4C41" />
                <h5>Baby & Pet Care</h5>
              </div>
            </animated.div>
          </Col>

          {/* Personal Care Category */}
          <Col md={2} sm={4} className="text-center mb-4 d-flex justify-content-center">
            <animated.div style={categoryAnimation}>
              <div
                style={{
                  padding: '20px',
                  borderRadius: '8px',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '200px',
                }}
              >
                <FaSpa size={50} color="#C2185B" />
                <h5>Personal Care</h5>
              </div>
            </animated.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const App = () => {
  return (
    <div>
      {/* Features Section */}
      <FeaturesSection />

      {/* Market Category Section */}
      <MarketCategory />
    </div>
  );
};

export default App;
